import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import {
    Observable,
    timer,
    defer,
} from 'rxjs';
import {
    finalize,
    take,
    takeWhile,
} from 'rxjs/operators';

import { LoaderService } from './loader.service';
import { StorageService } from './StorageService.service';


@Injectable()
export class IHttpInterceptorService implements HttpInterceptor {
    constructor(private loadingService: LoaderService, private storage: StorageService) {}
    alive = true;
    /**
     * Intercept all HTTP request to add JWT token to Headers
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof TokenInterceptor
     */
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
               Authorization: `Bearer ${this.storage.getToken()}`
            },
        });
        this.alive = true;
        return next.handle(request).pipe(
            prepare(() =>
                timer(500)
                    .pipe(
                        takeWhile(() => this.alive),
                        take(1)
                    )
                    .subscribe(() => {
                        this.loadingService.setLoading(true);
                    })
            ),
            finalize(() => {
                this.loadingService.setLoading(false);
                this.alive = false;
            })
        );
    }
    
   
    
}
export const prepare = <T>(callback: () => void) => {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source;
    });
};
   


